function copyLink() {
  if ($('#copy-link').length == 0) {
    return false;
  }

  var $temp = $('<input>');
  var $url = $(location).attr('href');
  $('#copy-link').on('click', function () {
    $('body').append($temp);
    $temp.val($url).select();
    document.execCommand('copy');
    $temp.remove();
    $('.copy-link-text').text(fpm001_localize.url_copied);
  });
}

export { copyLink }


// WEBPACK FOOTER //
// ./scripts/modules/share-list.js